<!--
* @Name：收货单状态变更申请审批页面
* @Author: 陈名刚
* @Date: 2024-05-13
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="对账状态变更审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">申请单</span>
        </template>
        <BaseInfo :model="model" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="model.files"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="details">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">明细</span>
        </template>
        <Details :pur-receiving-change-item-list="model.purReceivingChangeItemList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getPurReceivingChange } from '@/api/receiptStateChange'
import Bridge from '@/components/dsbridge'
export default {
  name: 'ReceiptStateChangeApproval',
  components: {
    BaseInfo: () => import('./components/BaseInfo.vue'),
    Details: () => import('./components/Details.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // 主单信息
      model: {}
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 获取采购申请主单信息和附件列表
    async initData() {
      const headResp = await getPurReceivingChange(this.$route.query.businessKey)
      this.model = headResp.data
    },
    // 返回到审批待办列表
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
